module.exports = __webpack_public_path__ + "img/banner.4e7a8c75.png";